import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a88aa9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generation-stats-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "main-title" }, "能量分析", -1))
const _hoisted_3 = { style: {"height":"500px"} }

import { GetEssEnergyAnalysisStats } from '@/api/evses'
import { EssEnergyChart } from '@/types/common/station'
import { StatisticsTimeGrain } from '@/types/types'
import { EssEnergyGrowthTrendChartData } from '@/views/DataV/Photovoltaic/types'
import { onMounted, ref, watch } from 'vue'
import EnergyAnalysisChartLine from '@/views/DataV/Photovoltaic/components/EnergyAnalysisChartLine.vue'

// 统计纬度

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const energyAnalysisCycle = ref<StatisticsTimeGrain>(StatisticsTimeGrain.STD_DAY)
const cycleList = [
  { label: '日', value: StatisticsTimeGrain.STD_DAY },
  { label: '周', value: StatisticsTimeGrain.STD_WEEK },
  { label: '月', value: StatisticsTimeGrain.STD_MONTH },
  { label: '年', value: StatisticsTimeGrain.STD_YEAR },
  { label: '总计', value: StatisticsTimeGrain.STD_TOTAL },
]

const essEnergyAnalysisStatsChartData = ref<EssEnergyGrowthTrendChartData>({})

const fetchEssEnergyAnalysisStats = () => {
  GetEssEnergyAnalysisStats({
    grain: energyAnalysisCycle.value,
  }).then((res: { list: EssEnergyChart[] }) => {
    essEnergyAnalysisStatsChartData.value = {
      xAxisData: res.list.map((item) => item.time),
      seriesData: [
        {
          name: '充电量',
          data: res.list.map((item) => item.chargeEnergy),
        },
        {
          name: '放电量',
          data: res.list.map((item) => item.dischargeEnergy),
        },
        {
          name: '负载功率',
          data: res.list.map((item) => item.loadPower),
        },
        {
          name: '光伏PV发电量',
          data: res.list.map((item) => item.chargeEnergyPV),
        },
        {
          name: '储能柜馈网电量',
          data: res.list.map((item) => item.feedbackGridEnergy),
        },
        {
          name: '光伏馈网电量',
          data: res.list.map((item) => item.feedbackGridEnergyPV),
        },
      ],
    }
  })
}
watch(energyAnalysisCycle, () => {
  fetchEssEnergyAnalysisStats()
})
onMounted(() => {
  fetchEssEnergyAnalysisStats()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_radio_group, {
      modelValue: energyAnalysisCycle.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((energyAnalysisCycle).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cycleList, (cycle) => {
          return _createVNode(_component_el_radio_button, {
            key: cycle.label,
            label: cycle.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(cycle.label), 1)
            ]),
            _: 2
          }, 1032, ["label"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(EnergyAnalysisChartLine, { data: essEnergyAnalysisStatsChartData.value }, null, 8, ["data"])
    ])
  ]))
}
}

})